<script>
    export default {
        props: {
            loading: Boolean,
            full: Boolean,
            light: Boolean
        }
    };
</script>

<template>
    <transition name="fade">
        <div class="preloader-component" :class="{ full, light }" v-if="loading">
            <div class="status">
                <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                </div>
            </div>
        </div>
    </transition>
</template>

<style lang="scss">
    .preloader-component {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(#fff, 0.5);
        z-index: 999;
        width: 100%;
        border-radius: inherit;

        &.full {
            position: fixed;
        }

        &.light {
            background-color: $light;
        }
    }
    .status {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin: -20px 0 0 -20px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
